var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "mail_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 5H5C3.35 5 2 6.35 2 8v9c0 1.65 1.35 3 3 3h14c1.65 0 3-1.35 3-3V8c0-1.65-1.35-3-3-3m0 2c.09 0 .16.03.24.05l-6.91 4.9a.9.9 0 0 1-.68 0L4.62 7.08C4.74 7.03 4.87 7 5 7zm0 11H5c-.55 0-1-.45-1-1V9.09l6.58 4.57.13.08c.39.19.83.29 1.27.29s.91-.1 1.31-.31L20 8.97V17c0 .55-.45 1-1 1"
})));
export default SvgMail;